
export enum TagStatus {
    NOT_STARTED = 'NOT_STARTED',
    IN_PROGRESS = 'IN_PROGRESS',
    COMPLETED = 'COMPLETED',
    PASSED = 'PASSED',
    MISSED = 'MISSED',
    CANCELLED = 'CANCELLED',
    FAILED = 'FAILED',
    PLANNED = 'PLANNED',
    ATTENDED = 'ATTENDED',
    COMPLIANT = 'COMPLIANT',
    RETURNED = 'RETURNED',
    INVITE_ENROLLMENT = 'INVITE_ENROLLMENT',
    SELF_ENROLLMENT = 'SELF_ENROLLMENT',
    NOT_REGISTERED = 'NOT_REGISTERED',
    NOT_APPLICABLE = 'NOT_APPLICABLE',
    INACTIVE = 'INACTIVE',
    ACTIVE = 'ACTIVE',
    FINAL_ASSESSMENT = 'FINAL_ASSESSMENT',
    NOT_SUBMITTED = 'NOT_SUBMITTED',
    SUBMITTED = 'SUBMITTED',
    EVALUATION = 'EVALUATION',
    MISSED_DEADLINE = 'MISSED_DEADLINE',
}